/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import {
  CreatePageDefinitionRequestDTO,
  Response,
  UpdatePageDefinitionRequestDTO,
} from "././index.d.ts";

export class Pages<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get page definition by page id.
   *
   * @tags uimanager
   * @name GetPageDefinition
   * @request GET:/pages/{pageId}
   * @secure
   */
  getPageDefinition = (pageId: string, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/pages/${pageId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing page definition.
   *
   * @tags uimanager
   * @name UpdatePageDefinition
   * @request PUT:/pages/{pageId}
   * @secure
   */
  updatePageDefinition = (
    pageId: string,
    data: UpdatePageDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/pages/${pageId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return all page definitions.
   *
   * @tags uimanager
   * @name ListPageDefinition
   * @request GET:/pages
   * @secure
   */
  listPageDefinition = (params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/pages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new page definition.
   *
   * @tags uimanager
   * @name CreatePageDefinition
   * @request POST:/pages
   * @secure
   */
  createPageDefinition = (
    data: CreatePageDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/pages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
